export default 'pilot/batch-records';
